module.exports = __webpack_public_path__ + "static/media/jatim.de80f70e.png";